import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({
    children,
    delay = 0,
    y = 28,
    className = "",
    ...rest
}) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    return (
        <span className={"block overflow-hidden " + className}>
            <motion.span
                className="block will-change-transform"
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1.1, delay, ease: EASE }}
            >
                {children}
            </motion.span>
        </span>
    );
}
